/**
 * @generated SignedSource<<8f7ee204de18fccd78293306cd7ced6f>>
 * @relayHash a44689c77b28af6f6fd9747bb353c271
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 66ca3f2d8ecb138cc7856523f4bec8ab9874e4b7ca770fa28b9be1dba24b2142

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type useIssueFetchAndAppendQuery$variables = {
  cloudId: string;
  fieldIdsOrAliases: ReadonlyArray<string>;
  fieldSetIds: ReadonlyArray<string>;
  isConditionalFormattingEnabled: boolean;
  isDensityFull: boolean;
  isInlineEditingEnabled: boolean;
  isLinkRelationshipFieldEnabled: boolean;
  isTimelineEnabled: boolean;
  issueKey: string;
  issueSearchInput: JiraIssueSearchInput;
  shouldQueryFieldsByIdOrAlias: boolean;
  shouldQueryMatchesIssueSearch: boolean;
};
export type useIssueFetchAndAppendQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly $updatableFragmentSpreads: FragmentRefs<"highlightIssueRow">;
      readonly __id: string;
      readonly fieldSetsById: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets">;
      };
      readonly fieldsByIdOrAlias?: ReadonlyArray<{
        readonly __typename: string;
        readonly fieldId: string;
        readonly fieldOption?: {
          readonly optionId: string;
        } | null | undefined;
        readonly number?: number | null | undefined;
        readonly priority?: {
          readonly priorityId: string;
        } | null | undefined;
        readonly selectedLabelsConnection?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly selectedOption?: {
          readonly optionId: string;
        } | null | undefined;
        readonly selectedOptions?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly optionId: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly selectedSprintsConnection?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly sprintId: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly selectedVersionsConnection?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly versionId: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status?: {
          readonly name: string | null | undefined;
          readonly statusId: string;
        };
        readonly user?: {
          readonly accountId: string;
        } | null | undefined;
        readonly version?: {
          readonly versionId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly issueId: string;
      readonly key: string;
      readonly matchesIssueSearch?: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useIssueFetchAndAppendQuery = {
  response: useIssueFetchAndAppendQuery$data;
  variables: useIssueFetchAndAppendQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldIdsOrAliases"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLinkRelationshipFieldEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldsByIdOrAlias"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryMatchesIssueSearch"
},
v12 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v15 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v16 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v17 = [
  {
    "kind": "Variable",
    "name": "idsOrAliases",
    "variableName": "fieldIdsOrAliases"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v20 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v21 = {
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v22/*: any*/)
      ]
    }
  ],
  "type": "JiraPriorityField"
},
v24 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v25 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v26 = [
  (v25/*: any*/)
],
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v29 = {
  "kind": "ScalarField",
  "name": "number"
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*: any*/)
  ],
  "type": "JiraNumberField"
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v21/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraLabelsField"
},
v32 = [
  {
    "concreteType": "JiraOptionConnection",
    "kind": "LinkedField",
    "name": "selectedOptions",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraOptionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v26/*: any*/)
          }
        ]
      }
    ]
  }
],
v33 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v34 = [
  (v33/*: any*/)
],
v35 = {
  "condition": "shouldQueryMatchesIssueSearch",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "issueSearchInput",
          "variableName": "issueSearchInput"
        }
      ],
      "kind": "ScalarField",
      "name": "matchesIssueSearch"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "type"
},
v37 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v38 = {
  "kind": "ScalarField",
  "name": "id"
},
v39 = {
  "kind": "ScalarField",
  "name": "value"
},
v40 = [
  (v39/*: any*/),
  (v38/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v41 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v42 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v43 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v44 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v45 = {
  "kind": "ScalarField",
  "name": "date"
},
v46 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "text"
},
v48 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v49 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v48/*: any*/),
    (v38/*: any*/)
  ]
},
v50 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v38/*: any*/)
  ]
},
v51 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v53 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v54 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v55 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v38/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "picture"
},
v57 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v58 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v59 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v60 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v61 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v62 = [
  (v38/*: any*/)
],
v63 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v62/*: any*/)
},
v64 = {
  "kind": "ScalarField",
  "name": "href"
},
v65 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v67 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v66/*: any*/),
  (v38/*: any*/)
],
v68 = [
  (v18/*: any*/),
  (v66/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v62/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v69 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
          (v38/*: any*/),
          (v14/*: any*/),
          {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v54/*: any*/),
                  (v38/*: any*/)
                ]
              },
              (v38/*: any*/)
            ]
          },
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v13/*: any*/),
                  (v38/*: any*/)
                ]
              },
              (v38/*: any*/)
            ]
          },
          (v13/*: any*/),
          {
            "concreteType": "JiraStatusField",
            "kind": "LinkedField",
            "name": "statusField",
            "plural": false,
            "selections": [
              (v55/*: any*/),
              (v38/*: any*/)
            ]
          },
          {
            "concreteType": "JiraSingleSelectUserPickerField",
            "kind": "LinkedField",
            "name": "assigneeField",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v56/*: any*/),
                  (v38/*: any*/)
                ]
              },
              (v38/*: any*/)
            ]
          },
          {
            "args": (v65/*: any*/),
            "kind": "LinkedField",
            "name": "startDateViewField",
            "plural": false,
            "selections": (v67/*: any*/),
            "storageKey": "startDateViewField(viewId:\"list_default\")"
          },
          {
            "args": (v65/*: any*/),
            "kind": "LinkedField",
            "name": "endDateViewField",
            "plural": false,
            "selections": (v67/*: any*/),
            "storageKey": "endDateViewField(viewId:\"list_default\")"
          }
        ]
      },
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "aggregatedStartDateViewField",
                "plural": false,
                "selections": (v68/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "aggregatedEndDateViewField",
                "plural": false,
                "selections": (v68/*: any*/)
              }
            ],
            "type": "JiraAggregatedTimelineField"
          }
        ]
      }
    ],
    "type": "JiraTimelineVirtualField",
    "abstractKey": "__isJiraTimelineVirtualField"
  }
],
v70 = [
  (v33/*: any*/),
  (v38/*: any*/)
],
v71 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": (v70/*: any*/)
    }
  ],
  "type": "JiraSingleVersionPickerField"
},
v72 = [
  (v18/*: any*/),
  (v38/*: any*/)
],
v73 = [
  (v25/*: any*/),
  (v38/*: any*/)
],
v74 = [
  {
    "concreteType": "JiraOptionConnection",
    "kind": "LinkedField",
    "name": "selectedOptions",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraOptionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v73/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useIssueFetchAndAppendQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "highlightIssueRow"
              },
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v15/*: any*/),
                  "concreteType": "JiraIssueFieldSetConnection",
                  "kind": "LinkedField",
                  "name": "fieldSetsById",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "isConditionalFormattingEnabled",
                          "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                          "kind": "Variable",
                          "name": "isDensityFull",
                          "variableName": "isDensityFull"
                        },
                        {
                          "kind": "Literal",
                          "name": "isEditableSyncLoaded",
                          "value": false
                        },
                        {
                          "kind": "Variable",
                          "name": "isInlineEditingEnabled",
                          "variableName": "isInlineEditingEnabled"
                        },
                        {
                          "kind": "Variable",
                          "name": "isLinkRelationshipFieldEnabled",
                          "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                          "kind": "Variable",
                          "name": "isTimelineEnabled",
                          "variableName": "isTimelineEnabled"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "IssueRow_fieldSets"
                    },
                    (v16/*: any*/)
                  ]
                },
                "action": "THROW",
                "path": "jira.issueByKey.fieldSetsById"
              },
              {
                "condition": "shouldQueryFieldsByIdOrAlias",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "kind": "LinkedField",
                    "name": "fieldsByIdOrAlias",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusField"
                      },
                      (v23/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectUserPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "fieldOption",
                            "plural": false,
                            "selections": (v26/*: any*/)
                          }
                        ],
                        "type": "JiraSingleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v27/*: any*/),
                            "concreteType": "JiraSprintConnection",
                            "kind": "LinkedField",
                            "name": "selectedSprintsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSprintEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "selectedSprintsConnection(first:1)"
                          }
                        ],
                        "type": "JiraSprintField"
                      },
                      (v30/*: any*/),
                      (v31/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "selectedOption",
                            "plural": false,
                            "selections": (v26/*: any*/)
                          }
                        ],
                        "type": "JiraRadioSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "JiraMultipleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "JiraCheckboxesField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "selectedVersionsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v34/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraMultipleVersionPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": (v34/*: any*/)
                          }
                        ],
                        "type": "JiraSingleVersionPickerField"
                      }
                    ]
                  }
                ]
              },
              (v35/*: any*/),
              (v16/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useIssueFetchAndAppendQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                          },
                          {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v36/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraIssueField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraAffectedServiceConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedAffectedServicesConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedServiceEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedService",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "serviceId"
                                                      },
                                                      (v21/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraAffectedServicesField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "parentOptionValue",
                                                "plural": false,
                                                "selections": (v40/*: any*/)
                                              },
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "childOptionValue",
                                                "plural": false,
                                                "selections": (v40/*: any*/)
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraCascadingSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbObjectConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedCmdbObjectsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "objectId"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "label"
                                                      },
                                                      {
                                                        "concreteType": "JiraCmdbAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                            "kind": "LinkedField",
                                                            "name": "mediaClientConfig",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "clientId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "fileId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "mediaBaseUrl"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "mediaJwtToken"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "url48"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraCMDBField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "args": (v42/*: any*/),
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v43/*: any*/),
                                                      (v44/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v45/*: any*/),
                                          (v21/*: any*/),
                                          (v46/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraDatePickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "dateTime"
                                          },
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraDateTimePickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraEpic",
                                            "kind": "LinkedField",
                                            "name": "epic",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "summary"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "color"
                                              },
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraEpicLinkField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "renderedFieldHtml"
                                          }
                                        ],
                                        "type": "JiraFallbackField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v47/*: any*/),
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatusCategory",
                                            "kind": "LinkedField",
                                            "name": "statusCategory",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v48/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusCategoryField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v20/*: any*/),
                                              (v49/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "args": (v42/*: any*/),
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "concreteType": "JiraLabelEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v21/*: any*/),
                                                      (v50/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                          },
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraLabelsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "small"
                                                  }
                                                ]
                                              },
                                              (v21/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "concreteType": "JiraColorField",
                                                "kind": "LinkedField",
                                                "name": "issueColorField",
                                                "plural": false,
                                                "selections": [
                                                  (v50/*: any*/),
                                                  (v38/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueTypeField",
                                                "kind": "LinkedField",
                                                "name": "issueTypeField",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v51/*: any*/),
                                                      (v21/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  },
                                                  (v38/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraSingleLineTextField",
                                                "kind": "LinkedField",
                                                "name": "summaryField",
                                                "plural": false,
                                                "selections": [
                                                  (v47/*: any*/),
                                                  (v38/*: any*/)
                                                ]
                                              },
                                              (v38/*: any*/),
                                              (v14/*: any*/),
                                              (v52/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                          "issuetype",
                                                          "project",
                                                          "summary",
                                                          "status"
                                                        ]
                                                      }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v18/*: any*/),
                                                              (v38/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v19/*: any*/),
                                                                  (v47/*: any*/)
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v19/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v38/*: any*/),
                                                                      (v53/*: any*/),
                                                                      (v21/*: any*/),
                                                                      (v51/*: any*/),
                                                                      (v54/*: any*/)
                                                                    ]
                                                                  }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v19/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v38/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v38/*: any*/),
                                                                          (v48/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "type": "JiraStatusField"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v53/*: any*/),
                                                          (v54/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraStatusField",
                                                    "kind": "LinkedField",
                                                    "name": "statusField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v19/*: any*/),
                                                      (v55/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraParentIssueField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v38/*: any*/)
                                            ]
                                          },
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraPriorityField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                  }
                                                ]
                                              },
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraProjectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraResolution",
                                            "kind": "LinkedField",
                                            "name": "resolution",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraResolutionField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprintEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprint",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v28/*: any*/),
                                                      (v21/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "state"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "endDate"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v21/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraSprintField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v21/*: any*/),
                                              (v56/*: any*/),
                                              (v57/*: any*/),
                                              (v38/*: any*/),
                                              (v24/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isUser"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v58/*: any*/),
                                                    "type": "AppUser"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": (v58/*: any*/)
                                                  }
                                                ],
                                                "type": "AppUser"
                                              }
                                            ]
                                          },
                                          (v46/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraRichText",
                                            "kind": "LinkedField",
                                            "name": "richText",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraADF",
                                                "kind": "LinkedField",
                                                "name": "adfValue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAdfToConvertedPlainText",
                                                        "kind": "LinkedField",
                                                        "name": "convertedPlainText",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "plainText"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "json"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraRichTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraServiceManagementRequestType",
                                            "kind": "LinkedField",
                                            "name": "requestType",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v51/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraServiceManagementRequestTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "args": (v27/*: any*/),
                                            "concreteType": "JiraIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "issueLinkConnection",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              {
                                                "concreteType": "JiraIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          (v52/*: any*/),
                                                          (v13/*: any*/),
                                                          {
                                                            "args": [
                                                              {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                  "statusCategory"
                                                                ]
                                                              }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v49/*: any*/)
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                      },
                                                                      (v38/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                          },
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "isResolved"
                                                              }
                                                            ]
                                                          },
                                                          (v38/*: any*/)
                                                        ]
                                                      },
                                                      (v59/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "issueLinkConnection(first:1)"
                                          }
                                        ],
                                        "type": "JiraIssueLinkField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "isStoryPointField"
                                          },
                                          (v29/*: any*/),
                                          (v21/*: any*/),
                                          (v41/*: any*/),
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraNumberFieldFormatConfig",
                                                "kind": "LinkedField",
                                                "name": "formatConfig",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "formatStyle"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "formatUnit"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraNumberField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraCommentSummary",
                                            "kind": "LinkedField",
                                            "name": "commentSummary",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "canAddComment"
                                              },
                                              (v37/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraCommentSummaryField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraUrlField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                              (v39/*: any*/),
                                              (v50/*: any*/),
                                              (v38/*: any*/),
                                              (v25/*: any*/)
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraSingleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v39/*: any*/),
                                                      (v25/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v39/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraCheckboxesField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      (v24/*: any*/),
                                                      (v21/*: any*/),
                                                      (v56/*: any*/),
                                                      (v38/*: any*/),
                                                      (v57/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "email"
                                                          }
                                                        ],
                                                        "type": "AtlassianAccountUser"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedId"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedName"
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraTeamViewField"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraTimeTrackingField",
                                                    "kind": "LinkedField",
                                                    "name": "timeTrackingField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v41/*: any*/),
                                                      (v60/*: any*/),
                                                      (v61/*: any*/),
                                                      (v19/*: any*/),
                                                      (v21/*: any*/),
                                                      (v36/*: any*/)
                                                    ]
                                                  },
                                                  (v38/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraOriginalTimeEstimateField"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraTimeTrackingField",
                                                    "kind": "LinkedField",
                                                    "name": "timeTrackingField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v60/*: any*/),
                                                      (v61/*: any*/),
                                                      (v38/*: any*/),
                                                      (v19/*: any*/),
                                                      (v21/*: any*/),
                                                      (v36/*: any*/)
                                                    ]
                                                  },
                                                  (v38/*: any*/)
                                                ]
                                              },
                                              (v41/*: any*/)
                                            ],
                                            "type": "JiraOriginalTimeEstimateField"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "label",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              },
                                              (v38/*: any*/),
                                              (v43/*: any*/)
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraRadioSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "args": (v42/*: any*/),
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v21/*: any*/),
                                                      (v43/*: any*/),
                                                      (v44/*: any*/),
                                                      (v33/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraMultipleVersionPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          (v63/*: any*/),
                                          {
                                            "args": (v42/*: any*/),
                                            "concreteType": "JiraGoalConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGoals",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGoalEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v13/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          (v21/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v16/*: any*/)
                                            ],
                                            "storageKey": "selectedGoals(first:1000)"
                                          },
                                          (v41/*: any*/),
                                          (v16/*: any*/)
                                        ],
                                        "type": "JiraGoalsField"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v21/*: any*/),
                                              (v63/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "isLinkEditable"
                                              },
                                              {
                                                "concreteType": "JiraTownsquareProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  (v38/*: any*/),
                                                  {
                                                    "alias": "atlasProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                  },
                                                  {
                                                    "alias": "atlasProjectKey",
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "privateProject"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "hasPermission"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isWorkspaceActive"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "iconName"
                                                  }
                                                ]
                                              },
                                              (v41/*: any*/)
                                            ],
                                            "type": "JiraTownsquareProjectField"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "args": (v42/*: any*/),
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v64/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "pageContent",
                                                            "plural": false,
                                                            "selections": [
                                                              (v18/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v64/*: any*/)
                                                                ],
                                                                "type": "JiraConfluencePageContentDetails"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v37/*: any*/)
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraConfluenceRemoteIssueLinksField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGroupEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v38/*: any*/),
                                                      (v21/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "groupId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "type": "JiraMultipleGroupPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraFlag",
                                            "kind": "LinkedField",
                                            "name": "flag",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "isFlagged"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraFlagField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraWatch",
                                            "kind": "LinkedField",
                                            "name": "watch",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "count"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "isWatching"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraWatchesField"
                                      },
                                      {
                                        "condition": "isLinkRelationshipFieldEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "concreteType": "JiraIssueLink",
                                                "kind": "LinkedField",
                                                "name": "issueLink",
                                                "plural": false,
                                                "selections": [
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "direction"
                                                  },
                                                  (v59/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueLinkType",
                                                    "kind": "LinkedField",
                                                    "name": "type",
                                                    "plural": false,
                                                    "selections": (v62/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v41/*: any*/)
                                            ],
                                            "type": "JiraIssueLinkRelationshipTypeField"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "isTimelineEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v69/*: any*/),
                                            "type": "JiraTimelineField"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v69/*: any*/),
                                            "type": "JiraAggregatedTimelineField"
                                          }
                                        ]
                                      },
                                      (v16/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "args": (v42/*: any*/),
                                                "concreteType": "JiraComponentConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedComponentsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "componentId"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                              }
                                            ],
                                            "type": "JiraComponentsField"
                                          },
                                          (v23/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          (v71/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  (v53/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraIssueTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "selectedValue",
                                                "plural": false,
                                                "selections": (v72/*: any*/)
                                              }
                                            ],
                                            "type": "JiraSingleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraSelectableValueConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedValues",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSelectableValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v72/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraMultipleSelectField"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              (v38/*: any*/),
              {
                "condition": "shouldQueryFieldsByIdOrAlias",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "kind": "LinkedField",
                    "name": "fieldsByIdOrAlias",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v38/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v38/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraPriorityField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v24/*: any*/),
                              (v38/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectUserPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "fieldOption",
                            "plural": false,
                            "selections": (v73/*: any*/)
                          }
                        ],
                        "type": "JiraSingleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v27/*: any*/),
                            "concreteType": "JiraSprintConnection",
                            "kind": "LinkedField",
                            "name": "selectedSprintsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSprintEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/),
                                      (v38/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "selectedSprintsConnection(first:1)"
                          }
                        ],
                        "type": "JiraSprintField"
                      },
                      (v30/*: any*/),
                      (v31/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "selectedOption",
                            "plural": false,
                            "selections": (v73/*: any*/)
                          }
                        ],
                        "type": "JiraRadioSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v74/*: any*/),
                        "type": "JiraMultipleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v74/*: any*/),
                        "type": "JiraCheckboxesField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "selectedVersionsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v70/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraMultipleVersionPickerField"
                      },
                      (v71/*: any*/),
                      (v38/*: any*/)
                    ]
                  }
                ]
              },
              (v35/*: any*/),
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "66ca3f2d8ecb138cc7856523f4bec8ab9874e4b7ca770fa28b9be1dba24b2142",
    "metadata": {},
    "name": "useIssueFetchAndAppendQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider
    }
  }
};
})();

(node as any).hash = "92fe6d9520071592f5157038f57aedf9";

export default node;
